"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(_ref) {
  var type = _ref.type;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: type === 'Group' ? 'Group may be unknown if it has since been archived or deleted' : 'User may be unknown because their account or license may have since been archived or deleted'
  }, /*#__PURE__*/_react["default"].createElement(_question["default"], {
    spaceLeft: true
  })));
};